import './App.css';
import {useEffect, useRef, useState} from "react";

import {FiSend} from "react-icons/fi";
import {FaHourglassHalf} from "react-icons/fa";

import {motion} from "framer-motion";

function ThinkingIndicator() {
    return (
        <motion.span
            className="h-3 w-3 rounded-full thinking-indicator"
            animate={{
                scale: [1, 1.4, 1],      // 살짝 커졌다 돌아오고
                opacity: [1, 0.4, 1],    // 동시에 투명도 변화
            }}
            transition={{
                duration: 1.2,           // 한 사이클 1.2초
                repeat: Infinity,        // 무한 반복
                ease: "easeInOut",
            }}
        />
    );
}

async function fetchMessage(logs) {
    const response = await fetch("/api/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({logs})
    });

    if (!response.ok) {
        throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data.message;
}

function getRandomVideo() {
    return Math.floor(Math.random() * 5) + 1;
}

function App() {
    const [logs, setLogs] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [inputText, setInputText] = useState("");
    const [currentVideo, setCurrentVideo] = useState(getRandomVideo());
    const videoRefs = useRef([]);

    const personName = "Bot";

    useEffect(() => {
        // scroll to the bottom of the chat logs whenever logs change
        const logsContainer = document.querySelector(".logs");
        if (logsContainer) {
            logsContainer.scrollTop = logsContainer.scrollHeight;
        }
    }, [logs]);

    async function submitMessage() {
        if (inputText.trim() === "") return;
        if (!isActive) return;

        setIsActive(false);
        setInputText("");
        setLogs((prevLogs) => [...prevLogs, inputText]);

        try {
            const response = await fetchMessage([...logs, inputText]);
            setLogs((prevLogs) => [...prevLogs, response]);
        } catch (error) {
            console.error("Error fetching message:", error);
            setLogs((prevLogs) => [...prevLogs, `Error fetching response: ${error.message}`]);
        }

        setIsActive(true);
    }

    useEffect(() => {
        console.log("Current video changed to:", currentVideo);

        videoRefs.current[currentVideo].play().catch((error) => {
            console.error("Error playing video:", error);
        });

        for (let i = 1; i <= 5; i++) {
            if (i !== currentVideo) {
                videoRefs.current[i].pause();
                videoRefs.current[i].currentTime = 0; // reset other videos
            }
        }
    }, [currentVideo]);

    function onVideoEnded() {
        setCurrentVideo((prev) => {
            let nextVideo = prev;

            do {
                nextVideo = getRandomVideo();
            } while (nextVideo === prev); // Ensure the next video is different from the current one

            console.log("Video ended, switching to video:", nextVideo);
            return nextVideo;
        });
    }

    return (
        <div className="wrapper">
            <video id={"video"} muted playsInline loop/>
            <video id={"mask"} muted playsInline loop/>
            <div className="screen">
                <img id="body-image" src="/data/body_image.png" alt="Body"/>
                {
                    [1, 2, 3, 4, 5].map((i) => {
                        const fn = `idle_${i.toString().padStart(3, '0')}`;

                        return (
                            <video id="canvas" playsInline muted key={i} ref={e => videoRefs.current[i] = e}
                                   style={{display: currentVideo === i ? '' : 'none'}}
                                   onEnded={onVideoEnded} preload={"auto"}
                            >
                                <source src={`/data/${fn}_safari.mov`} type='video/quicktime; codecs="hvc1"'/>
                                <source src={`/data/${fn}_chrome.webm`} type='video/webm; codecs=vp09.00.51.08'/>
                            </video>
                        )
                    })
                }
                <div className={"chat"}>
                    <div className={"logs"}>
                        {
                            logs.map((log, index) => {
                                if (index % 2 === 0) {
                                    return <div key={index} className={"msg log-user"}>{log}</div>;
                                } else {
                                    return (
                                        <div key={index} className={"log-bot-container"}>
                                            <span className={"bot-name"}>{personName}</span>
                                            <div className={"msg log-bot"}>
                                                {log}
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        }
                        {
                            !isActive && (
                                <div className={"log-bot-container"}>
                                    <span className={"bot-name"}>{personName} <ThinkingIndicator/></span>
                                    <div className={"msg log-bot log-bot-thinking"}>
                                        Thinking...
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className={"input-area"}>
                        <input id={"input-text"} type="text" placeholder="Type your message here..." value={inputText}
                               onChange={(e) => setInputText(e.target.value)}
                               onKeyDown={(e) => {
                                   if (e.key === 'Enter' && isActive) {
                                       submitMessage();
                                   }
                               }}
                        />
                        <button id={"input-button"} onClick={submitMessage}>
                            {isActive ? <FiSend size={18}/> : <FaHourglassHalf size={18}/>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
